import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

export default function setBrandsCarousel() {
    const brandsContainer = document.querySelector("[data-swiper-brands]");

    if (brandsContainer) {
        const brandsSwiper = new Swiper(brandsContainer.querySelector('.swiper'), {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 5,
            spaceBetween: 16,
            speed: 1000,
            watchOverflow: true,
            preloadImages: false,

            breakpoints: {
                992: {
                    slidesPerView: 8,
                },
                1368: {
                    slidesPerView: 10,
                },
            },

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            navigation: {
                nextEl: brandsContainer.querySelector('.swiper-button-next'),
                prevEl: brandsContainer.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: brandsContainer.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });

        brandsSwiper.autoplay.stop();

        const initAutoplay = () => {
            brandsSwiper.autoplay.start();
        }

        const eventType = (window.innerWidth <= 1024) ? 'scroll' : 'mousemove'
        window.addEventListener(eventType, initAutoplay, { once: true });
    }
}